<template>
  <nav>
    <img
      class="logo"
      src="@/assets/logo.svg"
    >
    <button
      @click="share"
      class="button"
    >Share</button>
  </nav>
  <ShareModal
    :show="showShareModal"
    @close="showShareModal = false"
  />
</template>

<script>
import { ref, onMounted } from "vue";
import ScrollMagic from "scrollmagic";
import ShareModal from "@/components/ShareModal";
import { useGtag } from "vue-gtag-next";
import sharing from "@/share";

export default {
  components: {
    ShareModal,
  },
  setup() {
    const { event } = useGtag();
    const showShareModal = ref(false);

    onMounted(() => {
      const controller = new ScrollMagic.Controller();
      new ScrollMagic.Scene({ triggerElement: "#Header", duration: "100%" })
        .setClassToggle("nav", "transparent")
        .addTo(controller);
    });

    async function share() {
      event("clicked_share_button", {
        event_category: "share",
        event_label: "share_button",
      });
      if ("share" in navigator) {
        try {
          const shareData = {
            title: sharing.main.title,
            text: `${sharing.main.desc} https://tclr.se/YearInCalling2020`,
            url: "https://www.truecaller.com/year-in-calling-2020",
          };
          await navigator.share(shareData);
          event("completed_native_share", {
            event_category: "share",
            event_label: "native_share",
          });
        } catch (err) {
          console.log(err);
          showShareModal.value = true;
        }
      } else {
        showShareModal.value = true;
      }
    }
    return {
      share,
      showShareModal,
    };
  },
};
</script>

<style>
nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 88px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.3);
  transition: all 0.5s ease;
  z-index: 100;
}
nav.transparent {
  background-color: transparent;
}
.logo {
  height: 26px;
  width: auto;
}
nav .button {
  height: 52px;
  line-height: 52px;
  min-width: auto;
  max-width: 124px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin: 0;
}
nav .button:hover {
  background: rgba(255, 255, 255, 0.3);
}
@media screen and (min-width: 720px) {
  nav .button {
    max-width: 196px;
  }
}
</style>